import React from 'react';

const PrivacyPolicyFunoAI = () => {
    return (
        <div className="min-h-screen bg-dark pt-24 pb-16">
            <div className="max-w-screen-md mx-auto px-6">
                <h1 className="text-3xl font-custom1 text-white mb-6">Privacy Policy</h1>

                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    This Privacy Policy explains how Funo AI Voice Changer ("we", "us", or "our") collects, uses, and protects your information when you use our mobile application.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Information We Collect</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We only collect your <strong className="text-white">Device ID</strong> when you use Funo AI. Device ID is required for app functionality, user registration, and managing in-app purchases.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">How We Use Your Information</h2>
                <ul className="list-disc ml-6 mb-6 text-gray-300 font-custom2">
                    <li>To enable core features of the app and maintain your user account.</li>
                    <li>To process digital product (in-app) purchases securely.</li>
                    <li>To personalize and serve ads within the app (ad networks may collect anonymous device information for advertising purposes).</li>
                    <li>To analyze usage trends and improve app performance.</li>
                </ul>

                <h2 className="text-2xl font-custom1 text-white mb-4">Data Sharing</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We do not sell or share your Device ID with third-party advertisers directly. However, advertising and analytics partners may collect anonymous data for ad targeting and measurement.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Data Retention</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We retain your Device ID for as long as your account is active or as required for app operations and legal compliance. You may request deletion of your data at any time.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">User Control & Account Deletion</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    If you would like to delete your Funo AI account and associated data, please contact us via email or use the in-app account deletion feature. All data will be permanently removed upon your request.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Children's Privacy</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    Funo AI Voice Changer is not intended for children under 13 years of age. We do not knowingly collect personal data from children. If such information is discovered, we will promptly delete it.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Purchases & Ads</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    Funo AI offers digital products for purchase within the app. Ads may be displayed by third-party ad networks, which may use device identifiers for ad personalization and measurement.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Updates to This Privacy Policy</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We may update this Privacy Policy from time to time. Any significant changes will be communicated through the app or app store updates.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Contact Information</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    If you have any questions or requests regarding this Privacy Policy or your data, please contact us at:<br />
                    Email: <a href="mailto:samedakgul99@gmail.com" className="text-accent-orange hover:underline">samedakgul99@gmail.com</a>
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicyFunoAI;
